import {getWorkspaceFromUri} from './getWorkspaceFromUri';

const CARVAGO_WORKSPACE = 'carvago';

/**
 * Carvago-only certificate features: the inspection equipment PDF, the formatted `ca-report`
 * comment and the static History check section. DMS applies the same equipment PDF rule in
 * `libs/dms/teas/src/components/VehicleInspection/utils/isCarvagoWorkspace.ts` (the app cannot
 * import `@dms/*`); keep the two in sync.
 */
export function isCarvagoWorkspace() {
  return getWorkspaceFromUri().workspace === CARVAGO_WORKSPACE;
}
